import { CiapCidSugestao } from 'graphql/types.generated'
import { createValidator, required } from 'util/validation'

import { ProblemaCondicaoModel } from '../problemas-condicoes/model-problemasCondicoes'
import { ciapCidCodigoToFormkey } from './operations-sugestoesProblemasHistoricoClinico'

export const sugestoesProblemasValidator = (
  ciapsCids: readonly CiapCidSugestao[],
  problemasAtendimentoAtual: ProblemaCondicaoModel[]
) =>
  createValidator({}, (formValues, errors) => {
    ciapsCids.forEach((ciapCid) => {
      const formKey = ciapCidCodigoToFormkey(ciapCid?.ciap?.codigo, ciapCid?.cid10?.codigo)
      const isCiapCidJaCadastrada = problemasAtendimentoAtual.some(
        (problemaCondicao) =>
          problemaCondicao?.ciap?.codigo === ciapCid.ciap?.codigo &&
          problemaCondicao?.cid?.codigo === ciapCid.cid10?.codigo &&
          problemaCondicao.incluirNaListaProblemas
      )
      if (!isCiapCidJaCadastrada) {
        errors[formKey] = required(formValues[formKey])
      }
    })

    return errors
  })
